import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import AccessDeniedPage from "./AccessDeniedPage";
import { useRouteAccess } from "../../hooks/useRouteAccess";
import { getRouteAccessKind } from "../../utils/routeAccess";

/**
 * Enforces route-level RBAC from {@link ROUTE_ACCESS_RULES} for every child route.
 */
const RouteAccessGuard: React.FC = () => {
  const { pathname } = useLocation();
  const access = getRouteAccessKind(pathname);
  const allowed = useRouteAccess(access);

  if (!allowed) {
    return <AccessDeniedPage access={access} />;
  }

  return <Outlet />;
};

export default RouteAccessGuard;
